let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("7BxbM")).then(() => parcelRequire('5ovLE'));